import { CustomerInterfaceLogLevel } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllInterfaceLogLevels = () => 
  getAllEnumOptions(CustomerInterfaceLogLevel)

export const getInterfaceLogLevelLabel = (
  key?: CustomerInterfaceLogLevel,
) => {
  if (key === null || typeof key === 'undefined') return ''

  return CustomerInterfaceLogLevel[key]
}